"use client";

import * as React from "react";
import * as RLabel from "@radix-ui/react-label";
import { cn } from "./cn";

export type LabelProps = React.ComponentPropsWithoutRef<typeof RLabel.Root>;

export const Label = React.forwardRef<
  React.ElementRef<typeof RLabel.Root>,
  LabelProps
>(({ className, ...props }, ref) => (
  <RLabel.Root
    ref={ref}
    className={cn(
      "block text-ink text-[11px] font-bold uppercase tracking-widest",
      className,
    )}
    {...props}
  />
));
Label.displayName = "Label";
